<template>
  <div class="space-y-8">
    <div class="flex justify-between items-center head">
      <Option :items="productState" @getOrderList="getOrder" :current_state="current_state"></Option>
      <Search :placeholder="$t('商品名称/订单号')" @search="search"></Search>
    </div>
    <div>

      <Body :data="items" @remove="doOrderList" @cancel="doOrderList" @finish="doOrderList" @updataPage="updataPage"
        @remind="doOrderList"></Body>
    </div>
  </div>
</template>

<script>
import { onMounted, reactive, ref } from "@vue/composition-api";
import Option from "@/components/mine/order/option.vue";
import Search from "@/components/mine/search.vue";
import Body from "/src/components/mine/order/body.vue";

export default {
  components: { Option, Search, Body },
  setup(props, ctx) {
    const items = ref();
    const productState = reactive({
      全部订单: "all",
      待付款: "unpay",
      待发货: "unsent",
      待收货: "sent",
      已完成: "finish",
      待评价: "uncomment",
      已取消: "cancel",
    });
    //当前状态
    const current_state = ref(ctx.root.$route.query.q || "unsent");
    //获取订单列表
    const getOrderList = async (val) => {
      ctx.root.$doing()
      const res = await ctx.root.$callapi("user/getOrderList", {
        page: 1,
        tag: val,
        size: 5,
      });
      ctx.root.$done()
      items.value = res.data;
    };
    const getOrder = (val) => {
      current_state.value = val;
      getOrderList(current_state.value);
    };
    onMounted(() => {
      getOrderList(current_state.value);
    });
    //搜索订单
    const search = async (e) => {
      if (e) {
        await ctx.root
          .$callapi("user/getOrderList", {
            page: 1,
            tag: current_state.value,
            size: 5,
            keyword: e,
          })
          .then((res) => {
            if (res.code === 0) {
              items.value = res.data;
            }
          });
      } else {
        getOrderList(current_state.value);
      }
    };
    //下一页
    const updataPage = async (page) => {
      await ctx.root
        .$callapi("user/getOrderList", {
          page: page,
          tag: current_state.value,
          size: 5,
        })
        .then((res) => {
          if (res.code === 0) {
            items.value = res.data;
          }
        });
    };
    //订单操作
    const doOrderList = async (...args) => {
      const des = {
        delete: ctx.root.$t("删除订单成功"),
        cancel: ctx.root.$t("订单取消成功"),
        finish: ctx.root.$t("确认收货成功"),
        remind: ctx.root.$t('提醒发货成功')
      };
      if (args[1] == 'remind') {
        let res = await ctx.root.$callapi('remindSend', {
          oid: args[0]
        })
        if (res.code == 0) {
          ctx.root.$toast(des[args[1]], "success");
        }
        return
      }
      await ctx.root
        .$callapi("user/doForOrderAction", {
          action: args[1],
          ids: [args[0]],
        })
        .then((res) => {
          if (res.code === 0) {
            ctx.root.$toast(des[args[1]], "success");
            getOrderList(current_state.value);
          }
        });
    };

    return {
      items,
      search,
      doOrderList,
      productState,
      getOrder,
      current_state,
      updataPage,
    };
  },
};
</script>

<style lang="scss">

</style>
